const textActionButton = (touchEditVisible: boolean) => ({
	opacity: touchEditVisible ? 1 : 0,
	pointerEvents: touchEditVisible ? 'auto' : 'none',
	transition: 'opacity 120ms ease-in-out, color 120ms ease-in-out',
	fontWeight: 700,
	textTransform: 'uppercase',
	minWidth: 0,
	backgroundColor: 'background.paper',
	paddingX: 1,
	'& .MuiTouchRipple-root': {
		color: 'primary.main'
	},
	'&:hover, &.Mui-focusVisible': {
		color: '#2196F3',
		backgroundColor: 'background.paper'
	}
});

export const cardEditActionsStyles = {
	actions: {
		position: 'absolute',
		top: 0,
		right: 8,
		transform: 'translateY(-50%)',
		display: 'flex',
		flexDirection: 'row',
		gap: 1,
		alignItems: 'center',
		paddingX: 1,
		zIndex: 1
	},

	editTextButton: textActionButton,

	inactivateTextButton: (touchEditVisible: boolean) => ({
		...textActionButton(touchEditVisible),
		color: 'text.secondary',
		'& .MuiTouchRipple-root': {
			color: 'text.secondary'
		},
		'&:hover, &.Mui-focusVisible': {
			color: 'text.primary',
			backgroundColor: 'background.paper'
		}
	}),

	reactivateTextButton: textActionButton
};

export const cardEditActionsHostStyles = {
	position: 'relative',
	'@media (hover: hover)': {
		'&:hover [data-card-pen], &:has(:focus-visible) [data-card-pen]': {
			opacity: 1,
			pointerEvents: 'auto'
		}
	}
} as const;
